import React from 'react';
import pt from 'prop-types';
import Link from '../../components/ui/link';
import { combine } from '../../helpers/styles';
import SocialIcons from '../socialIcons';
import Container from '../container';
import Text from '../../components/ui/text';
import CMSForm, {
  proptypes as formProps,
} from '/src/components/cms-modules/form';
import * as styles from './footer.module.scss';

const Footer = ({ siteSettings, isFooterBeige: customFooterIsBeige }) => {
  const {
    firstColumnHeadline,
    firstColumnLinks,
    secondColumnHeadline,
    secondColumnLinks,
    newsletter,
    copyrightText,
    footerIsBeige,
    socialLinks,
    footerIsBeige: globalFooterisBeige,
  } = siteSettings;
  return (
    <footer
      className={combine(
        styles.footer,
        (customFooterIsBeige || globalFooterisBeige) && styles.beige
      )}
      id="footer"
    >
      <Container>
        <div className={styles.outerContainer}>
          <div className={styles.firstColumn}>
            <div className={styles.linksSection}>
              {firstColumnLinks && (
                <div className={styles.footerItem}>
                  <Text as="p" type="metanavi" variant="semibold">
                    {firstColumnHeadline}
                  </Text>
                  <div className={styles.linksContainer}>
                    {firstColumnLinks.map((item, index) => (
                      <Link link={item} key={index}>
                        <Text as="span" type="metanavi">
                          {item.text}
                        </Text>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
              {secondColumnLinks && (
                <div className={styles.footerItem}>
                  <Text as="p" type="metanavi" variant="semibold">
                    {secondColumnHeadline}
                  </Text>
                  <div className={styles.linksContainer}>
                    {secondColumnLinks.map((item, index) => (
                      <Link link={item} key={index}>
                        <Text as="span" type="metanavi">
                          {item.text}
                        </Text>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {copyrightText && (
              <Text as="span" type="metanavi" className={styles.copyYear}>
                {copyrightText}
              </Text>
            )}
            <Text as="span" type="metanavi" className={styles.version}>
              {process.env.GATSBY_GIT_HASH}
            </Text>
          </div>
          <div className={styles.contactSection}>
            <div className={styles.newsletter}>
              <CMSForm
                inputLabel={newsletter.inputLabel}
                inputPlaceholder={newsletter.inputPlaceholder}
                btnLabel={newsletter.btnLabel}
                type={newsletter.type}
                inputClassName={styles.newsletterEmail}
                className={styles.cta}
                action={newsletter.action}
                onFooter
              />
            </div>
            <div className={styles.socials}>
              <SocialIcons socialLinks={socialLinks} />
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

Footer.propTypes = {
  siteSettings: pt.shape({
    firstColumnHeadline: pt.string,
    firstColumnLinks: pt.array,
    secondColumnHeadline: pt.string,
    secondColumnLinks: pt.array,
    newsletter: pt.shape(formProps),
    copyrightText: pt.string,
    socialLinks: pt.array,
    footerIsBeige: pt.bool,
  }),
  isFooterBeige: pt.bool,
};

Footer.defaultProps = {
  siteSettings: {
    firstColumnHeadline: '',
    firstColumnLinks: [],
    secondColumnHeadline: '',
    secondColumnLinks: [],
    copyrightText: '',
    socialLinks: [],
    footerIsBeige: false,
  },
  isFooterBeige: false,
};

export default Footer;
